module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/circles-afe3cbd8512c9ebfb894da1225380d4d.png";